export default "__VITE_ASSET__BHZimW_k__"